const scriptList = {
  bindings: {},
  templateUrl: '/modules/psa/script-list/script-list.html',
  controller: 'ScriptListController',
};

angular
  .module('psa.module')
  .component('scriptList', scriptList);
